export function Footer() {
    return (
        <div id="footer" className=" text-center p-4">
            <p className="m-0">KrisAuto srls - Servizio di acquisto auto incidentate in tutta Italia - Via del Girasole, 41126 San Damaso MODENA - P.IVA 03022850345 - Tel: +39 328 1028880 / +39 327 0743506 - Email: kristianvoukadinov62@gmail.com</p>
        </div>
    )
}